import styled from 'styled-components';

import BaseMoreHorizIcon from '@edna/icons/moreHoriz.svg';

export const MoreHorizIcon = styled(BaseMoreHorizIcon)`
  transform: rotate(90deg);
`;

export const OptionIcon = styled.svg<{isSmall?: boolean}>`
  margin-right: ${({theme, isSmall}) => (isSmall ? theme.spacing.s2 : theme.spacing.s4)};
`;
